var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3034_16299",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3034_16299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9467 12L8.87358 7.92689C8.73511 7.78844 8.66428 7.6144 8.66108 7.40479C8.65786 7.19519 8.72869 7.01795 8.87358 6.87309C9.01844 6.7282 9.19408 6.65576 9.40048 6.65576C9.60688 6.65576 9.78251 6.7282 9.92738 6.87309L14.4216 11.3673C14.5152 11.4609 14.5812 11.5596 14.6197 11.6635C14.6581 11.7673 14.6774 11.8795 14.6774 12C14.6774 12.1205 14.6581 12.2327 14.6197 12.3365C14.5812 12.4404 14.5152 12.5391 14.4216 12.6327L9.92738 17.1269C9.78893 17.2654 9.61489 17.3362 9.40527 17.3394C9.19568 17.3426 9.01844 17.2718 8.87358 17.1269C8.72869 16.982 8.65625 16.8064 8.65625 16.6C8.65625 16.3936 8.72869 16.218 8.87358 16.0731L12.9467 12Z",
    fill: "#F68B1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.57ac21e66f174ebf306a0b356b00fb79.svg";
export { ForwardRef as ReactComponent };